/**
 * Features/Why Choose Us Configuration
 * 
 * Defines the key differentiators and value propositions.
 */

export const FEATURES = [
  {
    id: 'proven-expertise',
    number: '01',
    title: 'Proven Expertise',
    description: 'A decade of experience delivering enterprise-grade solutions across industries including finance, healthcare, retail, and technology. Our track record speaks for itself.',
  },
  {
    id: 'innovation-first',
    number: '02',
    title: 'Innovation-First Approach',
    description: 'We stay ahead of technology trends to give your business a competitive edge. From AI to blockchain, we bring cutting-edge solutions that prepare you for tomorrow.',
  },
  {
    id: 'client-centric',
    number: '03',
    title: 'Client-Centric Delivery',
    description: 'Your success is our priority. We believe in transparent communication, agile collaboration, and building lasting partnerships that extend far beyond project completion.',
  },
  {
    id: 'end-to-end',
    number: '04',
    title: 'End-to-End Support',
    description: "From initial strategy and discovery through to deployment and ongoing optimisation, we're with you every step of the way. No handoffs, no gaps—just seamless delivery.",
  },
];
